import { AppsOption } from 'owa-apps-access-option';
import { checkMailboxExportStatus, ExportMailboxOption } from 'owa-export-mailbox-option';
import { ExternalImagesOption } from 'owa-external-images-option';
import { initializeBindStatusLazy } from 'owa-linkedin';
import { OptionSubCategory } from 'owa-options-core';
import { PrivacyOption } from 'owa-privacy-option';

let privacySubCategory: OptionSubCategory = {
    key: 'export',
    titleStringKey: 'optionSubcategory_privacy',
    options: [ExportMailboxOption, PrivacyOption, ExternalImagesOption, AppsOption],
    onSelected: async () => {
        checkMailboxExportStatus();
        await initializeBindStatusLazy.importAndExecute();
        return true;
    },
};

export default privacySubCategory;
